//GLOBAL - components from npm
import React, { useState, useRef, useEffect, Fragment } from "react";

//STYLES
import "./select-search.css";

//COMPONENTS
import { Tooltippy } from "../../actions/Tippy";
//import { ImageProfile, FieldContainer } from "../../data-display";
import ImageProfile from "../ImageProfile/ImageProfile";
//import FieldContainer from "../FieldContainer/FieldContainer";
import Typography from "../Typography";
import ButtonSelect from "../ButtonSelect";
import TooltipText from "../TooltipText/TooltipText";
//import { Typography, Button } from "../../general";
import Dots from "../Loading/Dots";
//import { Tooltippy } from "../../actions/Tippy";
//import { Loading } from "../../feedback";

// CUSTOM HOOKS
//import useOutsideClick from "../../components/NpsPage/hooks/useOutsideClick";
//import useOutsideClick from "../../../hooks/useOutsideClick";
import useOutsideClick from "../../utils/useOutsideClick";

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
import { ReactComponent as IconArrowDown } from "../../build/images/select-search-with-pagination/ArrowDown.svg";
import { ReactComponent as IconSearch } from "../../build/images/select-search-with-pagination/Search-normal.svg";
import { ReactComponent as EmptyFolder } from "../../build/images/select-search-with-pagination/empty-folder.svg";
import { ReactComponent as UserSearch } from "../../build/images/select-search-with-pagination/User-search.svg";
import { ReactComponent as IconDelete } from "../../build/images/select-search-with-pagination/icon-delete.svg";
import Tags from "./Components/Tags/Tags";

export default function SelectSearch({
  placeholder = "Pesquisar",
  value = undefined,
  width,
  top,
  style,
  disabled,
  className,
  tooltip = false,
  error = false,
  paginated = false,
  getOptions = () => null,
  showAvatar = true,
  onSelect = () => null,
  options = [
    {
      id: 1,
      label: "João Alves",
      caption1: "Ingenium",
      caption2: "#01232294101",
    },
    {
      id: 2,
      label: "João Costa",
      caption1: "Ingenium",
      caption2: "#01232294101",
    },
    {
      id: 3,
      label: "Lorenço Saraiva",
    },
    {
      id: 4,
      label: "Guilherme Gomes",
      caption1: "IngDesk",
    },
  ],
  onClose = () => null,
  contactSelect = false,
  contactEmpty = () => null,
  canBeEditable = true,
  valueDirect = false,
  multiple = false,
  limitTags = 2,
}) {
  //GENERAL
  const listStatus = [
    {
      id: 3,
      label: "Concluidos",
    },
    {
      id: 4,
      label: "Cancelados",
    },
    {
      id: 2,
      label: "Pendentes",
    },
    {
      id: 1,
      label: "Em andamento",
    },
    {
      id: 5,
      label: "Escalado",
    },
  ];

  // REFS
  const selectSearchRef = useRef(null);
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const sentinelRef = useRef(null);
  const buttonOptionRef = useRef(null);

  //STATES
  const [isOpen, setIsOpen] = useState(false);
  const [optionsInternal, setOptionsInternal] = useState(
    !paginated ? options : [],
  );
  const [currentOptionData, setCurrentOptionData] = useState();
  const [currentOptionDisplay, setCurrentOptionDisplay] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState();
  const [page, setPage] = useState(1);
  const [isRequesting, setIsRequesting] = useState(false);
  const [isSentinelVisible, setIsSentinelVisible] = useState(paginated);
  const [lengthOption, setLengthOption] = useState(50);

  //REDUX - Selectors
  //console.log("value", { value, currentOptionData, currentOptionDisplay });

  //FUNCTIONS
  let maxHeight = "280px";
  if (optionsInternal.filter(filterOptions)) {
    maxHeight =
      optionsInternal.filter(filterOptions).length < 1 ? "none" : "280px";
  }

  const combinedStyle = {
    maxHeight: maxHeight,
    top: top ? top : "",
    zIndex: 12,
  };

  async function updateOptions(title, page) {
    if (!paginated) return;

    setIsRequesting(true);
    const data = await getOptions(title, page);

    if (data.length > 0) {
      setIsSentinelVisible(true);
    }

    if (page > 1) {
      setOptionsInternal((oldState) => oldState.concat(data));
    } else {
      setOptionsInternal(data);
    }
    setIsRequesting(false);
  }

  function getOptionKey(option) {
    if (!option) return undefined;
    return option.value !== undefined ? option.value : option.id;
  }

  function isSameOption(a, b) {
    const aKey = getOptionKey(a);
    const bKey = getOptionKey(b);
    return aKey !== undefined && aKey === bKey;
  }

  function isOptionSelected(option) {
    return selectedOptions.some((selected) => isSameOption(selected, option));
  }

  function optionItemClass(opt) {
    if (multiple) {
      return isOptionSelected(opt) ? "select-search-list__item--selected" : "";
    }
    return opt.value === (currentOptionData && currentOptionData.value)
      ? "active"
      : "";
  }

  function filterOptions(option) {
    if (paginated) return option;

    if (currentOptionDisplay) {
      if (
        option.label.toLowerCase().includes(currentOptionDisplay.toLowerCase())
      ) {
        return option;
      } else return;
    } else {
      return option;
    }
  }

  function resetState(
    props = {
      options: false,
      listScrollPosition: false,
      currentOptionDisplay: false,
      page: false,
      searchTerm: false,
    },
  ) {
    props.options && updateOptions("", 1);
    props.listScrollPosition &&
      listRef.current &&
      listRef.current.scroll({ top: 0 });
    props.currentOptionDisplay &&
      setCurrentOptionDisplay(currentOptionData ? currentOptionData.label : "");
    props.page && setPage(1);
    props.searchTerm && setSearchTerm("");
  }

  function onClickLabel() {
    if (!isOpen) {
      setIsOpen(true);
      if (canBeEditable) {
        setCurrentOptionDisplay("");
      }
    }

    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  function handleOnClickLabel() {
    if (disabled || !canBeEditable) {
      return null;
    } else {
      onClickLabel();
    }
  }

  function onClickOption(option) {
    if (multiple) {
      const alreadySelected = isOptionSelected(option);
      const newSelected = alreadySelected
        ? selectedOptions.filter((selected) => !isSameOption(selected, option))
        : [...selectedOptions, option];

      setSelectedOptions(newSelected);
      onSelect(newSelected);

      // setCurrentOptionDisplay("");
      // setSearchTerm("");
      // resetState({
      //   options: true,
      //   listScrollPosition: false,
      //   page: page > 1,
      // });

      if (inputRef.current) {
        inputRef.current.focus();
      }
      return;
    }

    if (option.label === null || option.label === undefined) {
      setCurrentOptionDisplay(option.nome);
    } else {
      setCurrentOptionDisplay(option.label);
    }

    setCurrentOptionData(option);
    onSelect(option);

    setIsOpen(false);
    resetState({
      options: true,
      listScrollPosition: true,
      page: page > 1,
      searchTerm: true,
    });
  }

  function observerCallback(entries) {
    if (isOpen && entries[0].isIntersecting) {
      setIsSentinelVisible(false);
      updateOptions(searchTerm, page + 1);
      setPage(page + 1);
    }
  }

  function observerCallbackDefault(entries) {
    setIsRequesting(true);
    if (isOpen && entries[0].isIntersecting) {
      if (lengthOption < optionsInternal.length) {
        setLengthOption((prevValue) => prevValue + 50);
      }

      setIsRequesting(false);
    }
  }

  // CUSTOM HOOKS
  useOutsideClick(
    selectSearchRef,
    () => {
      if (isOpen) {
        setIsOpen(false);
        resetState({
          options: true,
          listScrollPosition: true,
          currentOptionDisplay: true,
          searchTerm: true,
        });

        if (page !== 1) setPage(1);
      }
    },
    buttonOptionRef,
  );

  //USE EFFECT
  useEffect(() => {
    updateOptions(currentOptionDisplay, page);
  }, []);

  useEffect(() => {
    if (!paginated) {
      setOptionsInternal(options);
    }
  }, [options]);

  useEffect(() => {
    if (multiple) {
      setSelectedOptions(Array.isArray(value) ? value : []);
      return;
    }

    if (valueDirect) {
      let valueObject = options.find((opt) => opt.value === value);

      setCurrentOptionData(valueObject);

      if (valueObject) {
        setCurrentOptionDisplay(valueObject.label);
      } else {
        setCurrentOptionDisplay(undefined);
      }
    } else if (
      value &&
      value.value !== (currentOptionData && currentOptionData.value)
    ) {
      let valueObject;

      if ((value && value.value) || paginated) {
        valueObject = value;
      } else {
        valueObject = options.find((opt) => opt.value === value);
      }

      setCurrentOptionData(valueObject);

      setCurrentOptionDisplay(valueObject ? valueObject.label : undefined);
    } else if (value === undefined) {
      setCurrentOptionData(undefined);
      setCurrentOptionDisplay("");
    }
  }, [value]);

  useEffect(() => {
    if (paginated && isOpen && sentinelRef.current) {
      let options = {
        root: listRef.current,
        rootMargin: "0px",
        threshold: 0.1,
      };

      if (listRef.current.scrollHeight > 260) {
        let observer = new IntersectionObserver(observerCallback, options);
        observer.observe(sentinelRef.current);

        return () => observer.disconnect();
      }
    }
  }, [sentinelRef.current, isOpen, isRequesting]);

  useEffect(() => {
    if (!paginated && isOpen && sentinelRef.current) {
      let options = {
        root: listRef.current,
        rootMargin: "0px",
        threshold: 0.1,
      };

      if (listRef.current.scrollHeight > 260) {
        let observer = new IntersectionObserver(
          observerCallbackDefault,
          options,
        );
        observer.observe(sentinelRef.current);

        return () => observer.disconnect();
      }
    } else {
      setLengthOption(50);
    }
  }, [isOpen, sentinelRef.current]);

  return (
    <>
      <div
        ref={selectSearchRef}
        className={`select-search ${className ? className : ""} ${
          isOpen ? "select-search--active" : ""
        } ${error ? "select-search--error" : ""}`}
        style={{ width: width ? width : "" }}
      >
        <div
          style={style}
          className={`select-search-btn 
          ${disabled ? "select-search-btn--disabled" : "select-search-btn"}`}
          onClick={handleOnClickLabel}
        >
          {
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
                gap: "3px",
                width: "calc(100% - 25px)",
              }}
            >
              {multiple && (
                <Tags
                  limitTags={limitTags}
                  selectedOptions={selectedOptions}
                  getOptionKey={getOptionKey}
                  onClickOption={onClickOption}
                  disabled={disabled}
                />
              )}
              <input
                style={{ flex: "1" }}
                ref={inputRef}
                className={`select-search-btn__input ${
                  !canBeEditable ? "width" : ""
                }`}
                value={currentOptionDisplay}
                placeholder={
                  multiple && selectedOptions.length > 0 ? "" : placeholder
                }
                disabled={canBeEditable ? false : true}
                onChange={(event) => {
                  !isOpen && setIsOpen(true);
                  setCurrentOptionDisplay(event.target.value);

                  if (paginated && event.target.value.length === 0) {
                    resetState({
                      options: true,
                      page: true,
                      searchTerm: true,
                      listScrollPosition: true,
                    });
                  }
                }}
                onKeyDown={(event) => {
                  event.stopPropagation();
                  console.log("event", event.key);
                  if (event.key === "Enter" || event.key === "NumpadEnter") {
                    event.preventDefault();
                    resetState({
                      //options: paginated,
                      listScrollPosition: true,
                      page: paginated,
                    });

                    updateOptions(event.target.value, 1);
                    setSearchTerm(event.target.value);
                  }
                }}

                /*
                onKeyPress={(event) => {
                  if (
                    (event.code === "Enter" || event.code === "NumpadEnter") &&
                    event.target.value !== searchTerm
                  ) {
                    resetState({
                      //options: paginated,
                      listScrollPosition: true,
                      page: paginated,
                    });

                    updateOptions(event.target.value, 1);
                    setSearchTerm(event.target.value);
                  }
                }}
                */
              />
              {multiple ? (
                selectedOptions.length > 0 && !isOpen ? null : null
              ) : currentOptionDisplay && !isOpen ? (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentOptionData(undefined);
                    setCurrentOptionDisplay("");
                    onSelect(undefined);
                  }}
                >
                  <IconDelete />
                </span>
              ) : null}
            </div>
          }
          {canBeEditable &&
            (isOpen ? (
              <IconSearch
                className="select-search-btn__iconBase"
                onClick={(event) => {
                  event.stopPropagation();
                  resetState({
                    //options: paginated,
                    listScrollPosition: true,
                    page: paginated,
                  });
                  setSearchTerm(currentOptionDisplay);
                  updateOptions(currentOptionDisplay, 1);
                }}
              />
            ) : (
              <IconArrowDown
                className="select-search-btn__iconBase"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOnClickLabel();
                }}
              />
            ))}
        </div>

        {canBeEditable && (
          <div
            className="select-search-list"
            ref={listRef}
            style={combinedStyle}
          >
            {(optionsInternal.filter(filterOptions) &&
              optionsInternal.filter(filterOptions).length) > 0 ? (
              <div>
                {optionsInternal
                  .filter(filterOptions)
                  .slice(0, paginated ? optionsInternal.length : lengthOption)
                  .map((opt, index) => (
                    <Fragment key={`select-search-${index}`}>
                      {tooltip ? (
                        <Tooltippy
                          content={
                            opt.label ? (
                              <div>
                                <div>{opt.label}</div>
                                {opt.caption1 || opt.caption1 === 0 ? (
                                  <div>{opt.caption1}</div>
                                ) : null}
                                {opt.caption2 || opt.caption2 === 0 ? (
                                  <div>{opt.caption2}</div>
                                ) : null}
                              </div>
                            ) : (
                              ""
                            )
                          }
                        >
                          <div>
                            <button
                              ref={buttonOptionRef}
                              style={{ width: "100%" }}
                              type="button"
                              className={`select-search-list__item ${optionItemClass(
                                opt,
                              )}`}
                              onClick={(event) => {
                                event.stopPropagation();
                                onClickOption(opt);
                              }}
                            >
                              {showAvatar && (
                                <ImageProfile
                                  profile={{
                                    nome_usuario: opt.label,
                                    nome_organizacao: opt.caption1,
                                  }}
                                  tooltip={false}
                                />
                              )}

                              <div className="item-info">
                                <Typography.H5
                                  weight="bold"
                                  color="gray-400"
                                  className="item-info__label"
                                >
                                  {opt.label ? opt.label : "Title"}
                                </Typography.H5>
                                {opt.caption1 && (
                                  <Typography.H5
                                    color="gray-400"
                                    className="item-info__caption"
                                  >
                                    {opt.caption1}
                                  </Typography.H5>
                                )}
                                {opt.caption2 && (
                                  <Typography.H5
                                    color="gray-400"
                                    className="item-info__caption"
                                  >
                                    {opt.caption2}
                                  </Typography.H5>
                                )}
                              </div>
                            </button>
                          </div>
                        </Tooltippy>
                      ) : (
                        <button
                          ref={buttonOptionRef}
                          style={{ width: "100%" }}
                          type="button"
                          className={`select-search-list__item ${
                            opt.value ===
                            (currentOptionData && currentOptionData.value)
                              ? "active"
                              : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            onClickOption(opt);
                          }}
                        >
                          {showAvatar && (
                            <ImageProfile
                              profile={{
                                nome_usuario: opt.label,
                                nome_organizacao: opt.caption1,
                              }}
                              tooltip={false}
                            />
                          )}

                          <div className="item-info">
                            <Typography.H5
                              weight="bold"
                              color="gray-400"
                              className="item-info__label"
                            >
                              {opt.label ? opt.label : "Title"}
                            </Typography.H5>
                            <div className="captions-container">
                              {opt.caption1 && (
                                <Typography.H5
                                  color="gray-180"
                                  className="item-info__caption"
                                >
                                  {opt.caption1}
                                </Typography.H5>
                              )}
                              {opt.caption1 && opt.caption2 && (
                                <Typography.H5
                                  color="gray-180"
                                  className="item-info__caption"
                                >
                                  •
                                </Typography.H5>
                              )}
                              {opt.caption2 && (
                                <Typography.H5
                                  color="gray-180"
                                  className="item-info__caption"
                                >
                                  {opt.caption2}
                                </Typography.H5>
                              )}
                            </div>
                            <div className="captions-container">
                              {opt.caption3 && (
                                <Typography.H5
                                  color="gray-180"
                                  className="item-info__caption"
                                >
                                  {opt.caption3}
                                </Typography.H5>
                              )}
                              {opt.caption3 && opt.caption4 && (
                                <Typography.H5
                                  color="gray-180"
                                  className="item-info__caption"
                                >
                                  •
                                </Typography.H5>
                              )}
                              {opt.caption4 && (
                                <Typography.H5
                                  color="gray-180"
                                  className={`item-info__caption ${
                                    opt.caption3 ? "second-caption" : ""
                                  }`}
                                >
                                  {opt.caption4}
                                </Typography.H5>
                              )}
                            </div>
                            {opt.caption5 && (
                              <Typography.H5
                                color="gray-180"
                                className="item-info__caption"
                              >
                                {opt.caption5}
                              </Typography.H5>
                            )}
                          </div>
                        </button>
                      )}
                    </Fragment>
                  ))}
                {isOpen && paginated && isSentinelVisible && (
                  <div
                    className="select-search-list__sentinel"
                    ref={sentinelRef}
                  ></div>
                )}
                {isOpen && !paginated && (
                  <div
                    className="select-search-list__sentinel"
                    ref={sentinelRef}
                  ></div>
                )}
                {isOpen && isRequesting && (
                  <div className="loading-container">
                    <Dots width={50} height={50} />
                  </div>
                )}
              </div>
            ) : contactSelect ? (
              <div className="select-search-list__contact-empty">
                <div className="container-icon">
                  <UserSearch />
                </div>
                <Typography.H5>
                  Não encontramos nenhum contato. Deseja adicionar este contato?
                </Typography.H5>
                <ButtonSelect onClick={contactEmpty}>
                  Adicionar Contato
                </ButtonSelect>
              </div>
            ) : (
              <div className="select-search-list__empty">
                <EmptyFolder />
                <Typography.H6>Não encontramos resultados.</Typography.H6>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
